export const iconFontAwesomeDevicesHardwareMicrochip = (
	<i className="fa-solid fa-microchip"></i>
);
